import { render, staticRenderFns } from "./ModuleKnowlegeAnalyze.vue?vue&type=template&id=68334628&scoped=true"
import script from "./ModuleKnowlegeAnalyze.vue?vue&type=script&lang=js"
export * from "./ModuleKnowlegeAnalyze.vue?vue&type=script&lang=js"
import style0 from "./ModuleKnowlegeAnalyze.vue?vue&type=style&index=0&id=68334628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68334628",
  null
  
)

export default component.exports